import React from 'react';
import TextIcon from '@atlaskit/icon/core/text';
import TextField from '@atlassian/jira-issue-create-commons/src/ui/text-field/index.tsx';
import { TEXT_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import { TextFieldPlaceholder } from '../../../ui/field-placeholders/index.tsx';
import type { FieldTypeConfig } from '../types.tsx';
import { textFieldWriter } from '../writers/index.tsx';

export const TextCustomFieldTypeConfig: FieldTypeConfig<string> = {
	icon: TextIcon,
	type: TEXT_CF_TYPE,
	Component: TextField,
	placeholder: <TextFieldPlaceholder />,
	writer: textFieldWriter,
};
